@if (initialized && kpiHeaderDto) {

    <kpi-header [itemsArray]="kpiHeaderDto" [breadcrumb]="items" configRoute="/um/config"
    ></kpi-header>


}